// extracted by mini-css-extract-plugin
export default {"container":"iY-z","title":"jY-z","link":"kY-z"};